<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <v-card :disabled="submitting">
      <v-form @submit.prevent="handleSubmit">
        <v-card-title>
          {{ __("formulários") }}
          <v-spacer></v-spacer>
          <v-btn @click="handleClose" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-list style="margin-left: -10px">
            <v-subheader>{{ __("ESCOLHA OS FORMULÁRIOS") }}</v-subheader>

            <v-list-item-group v-model="selectedForms" color="primary" multiple>
              <v-list-item
                v-for="form in forms"
                :key="form.id"
                :value="form.id"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active"></v-checkbox>
                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title v-text="form.name"></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>

          <v-alert
            v-if="!loadingForms && forms.length === 0"
            type="info"
            dense
            text
          >
            {{ __("Nenhum formulário encontrado para este subtipo de lead.") }}
          </v-alert>

          <v-text-field
            v-model="email"
            :label="__('destinatário')"
            prepend-inner-icon="mdi-email"
            type="email"
            filled
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-btn
            type="submit"
            color="primary"
            block
            large
            :disabled="!canSubmit"
            :loading="submitting"
          >
            {{ __("enviar") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/mixins/i18n";
import { fillAndSendByEmail } from "@/services/form_filler/form_filler.js";
import { indexBySubtype } from "@/services/forms/form_templates.js";

export default {
  props: {
    lead_number: String,
    subtype_id: String,
  },

  mixins: [i18n],

  data() {
    return {
      i18n_prefix: "file",
      dialog: false,
      email: "",
      forms: [],
      selectedForms: [],
      submitting: false,
      loadingForms: false,
    };
  },

  methods: {
    handleClose() {
      this.dialog = false;
    },

    async handleSubmit() {
      this.submitting = true;

      try {
        await fillAndSendByEmail({
          template_ids: this.selectedForms,
          lead_number: this.lead_number,
          email: this.email,
        });

        this.handleClose();
      } finally {
        this.submitting = false;
      }
    },

    async init() {
      this.dialog = true;
      this.email = "";
      this.selectedForms = [];

      await this.loadForms();
    },

    async loadForms() {
      if (!this.subtype_id) {
        this.forms = [];
        return;
      }

      this.loadingForms = true;

      try {
        const response = await indexBySubtype(this.subtype_id);
        this.forms = response.data || [];
      } finally {
        this.loadingForms = false;
      }
    },
  },

  computed: {
    canSubmit() {
      if (this.selectedForms.length === 0) {
        return false;
      }

      if (!this.email) {
        return false;
      }

      return true;
    },
  },

  created() {
    this.loadForms();
  },
};
</script>
